module.exports = __webpack_public_path__ + "img/base1.221980e4.png";